export default __webpack_public_path__ + "static/media/Background 5_00025.b1d3a9a7.png";